import Dropzone from "react-dropzone";
import CryptoJS from "crypto-js";
import React, { Component, createRef, Fragment, PureComponent } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import TrendingUp from "@material-ui/icons/TrendingUp";
import TrendingDown from "@material-ui/icons/TrendingDown";
import Add from "@material-ui/icons/Add";
import Amplify, { Auth, Storage } from "aws-amplify";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import InputAdornment from "@material-ui/core/InputAdornment";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import TextField from "@material-ui/core/TextField";
import API from "@aws-amplify/api";
import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";
import awsmobile from "./../../aws-exports";
// import AceEditor from "react-ace";
// import "ace-builds/src-noconflict/mode-sql";
// import "ace-builds/src-noconflict/theme-tomorrow";
import ReactTable from "react-table";
import Assignment from "@material-ui/icons/Assignment";
import CardIcon from "components/Card/CardIcon.jsx";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
// import { FixedSizeList as List, FixedSizeGrid } from "react-window";
//import InfiniteLoader from "react-window-infinite-loader";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

Amplify.configure(awsmobile);
// core components
const uuidv4 = require("uuid/v4");
const styles = {
  cardTitle,
  pageSubcategoriesTitle: {
    color: "#3C4858",
    textDecoration: "none",
    textAlign: "center",
  },
  cardCategory: {
    margin: "0",
    color: "#999999",
  },
};
let apiName = process.env.REACT_APP_AMPLIFY_API;

const LOADING = 1;
const LOADED = 2;
let itemStatusMap = {};

const isItemLoaded = (index) => !!itemStatusMap[index];
const loadMoreItems = (startIndex, stopIndex) => {
  for (let index = startIndex; index <= stopIndex; index++) {
    itemStatusMap[index] = LOADING;
  }
  return new Promise((resolve) =>
    setTimeout(() => {
      for (let index = startIndex; index <= stopIndex; index++) {
        itemStatusMap[index] = LOADED;
      }
      resolve();
    }, 2500)
  );
};

class Cell extends PureComponent {
  render() {
    const {
      columnIndex,
      rowIndex,
      style,
      data: { rows, columns },
    } = this.props;
    if (!rows) return <div className="ListItem" style={style} />;

    const col = columns[columnIndex];
    if (!col || !rows[rowIndex])
      return <div className="ListItem" style={style} />;
    const val = rows[rowIndex][col.accessor];

    if (!val) return <div className="ListItem" style={style} />;

    return (
      <div className="ListItem" style={style}>
        <hr />
        {val}
      </div>
    );
  }
}

class QueryTool extends React.Component {
  constructor() {
    super();
    this.state = {
      query: "",
      columns: [],
      data: [],
      runQueryDisable: true,
      emailModal: false,
      emailaddress: "",
      querytitle: "",
      errors: {},
      loading: false,
    };
  }
  handleModalInput = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };
  handleChange = (event) => {
    if (event === "") {
      this.setState({ runQueryDisable: true });
    } else {
      this.setState({ runQueryDisable: false });
    }
    this.setState({ query: event });
  };
  sendEmail() {
    if (this.state.query.split(" ")[0].toLocaleLowerCase() == "select") {
      if (this.state.emailaddress == "") {
        let err = {};
        err["emailaddress"] = "Please enter Email Address";
        this.setState({ errors: err });
        setTimeout(
          function() {
            this.setState({
              errors: (err["emailaddress"] = ""),
            });
          }.bind(this),
          3000
        );
      } else if (this.state.querytitle == "") {
        let err = {};
        err["querytitle"] = "Please enter title";
        this.setState({ errors: err });
        setTimeout(
          function() {
            this.setState({
              errors: (err["querytitle"] = ""),
            });
          }.bind(this),
          3000
        );
      } else {
        fetch(
          "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/querytool",
          {
            method: "post",
            body: JSON.stringify({
              querytitle: this.state.querytitle,
              toemail: this.state.emailaddress,
              param: "emailres",
              query: this.state.query,
              database: JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("custDb"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              ),
            }),
          }
        )
          .then((res) => res.json())
          .then((result) => {
            this.setState({ emailModal: false });
          });
      }
    } else {
      let err = {};
      err["sqlerror"] = "Supports only select clause";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["sqlerror"] = ""),
          });
        }.bind(this),
        5000
      );
    }
  }
  runQuery() {
    if (this.state.query.substring(0, 6).toLocaleLowerCase() == "select") {
      this.setState({ columns: [] });
      this.setState({ data: [] });
      this.setState({ loading: true });
      fetch(
        "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/querytool",
        {
          method: "post",
          body: JSON.stringify({
            param: "queryres",
            query: this.state.query,
            database: JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ),
          }),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          this.setState({ loading: false });
          if (typeof result === "string") {
            let err = {};
            err["sqlerror"] = result;
            this.setState({ errors: err });
            setTimeout(
              function() {
                this.setState({
                  errors: (err["sqlerror"] = ""),
                });
              }.bind(this),
              3000
            );
          } else {
            this.setState({ columns: result[0] });
            this.setState({ data: result[1] });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          let err = {};
          err["sqlerror"] = "Query Timed out";
          this.setState({ errors: err });
          setTimeout(
            function() {
              this.setState({
                errors: (err["sqlerror"] = ""),
              });
            }.bind(this),
            3000
          );
        });
    } else {
      let err = {};
      err["sqlerror"] = "Supports only select clause";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["sqlerror"] = ""),
          });
        }.bind(this),
        5000
      );
    }
  }
  componentDidMount() {}

  render() {
    const { classes } = this.props;
    let showSpinner =
      this.state.loading === true ? (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div
              style={{ textAlign: "center", marginTop: "20px", width: "100%" }}
            >
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: "50px" }}
              />
            </div>
          </GridItem>
        </GridContainer>
      ) : (
        "No records found"
      );
    return (
      <div>
        <div>
          <h3 style={{ display: "inline" }}>Query Editor</h3>
          <Button
            onClick={() => this.setState({ emailModal: true })}
            className="btn btncreate"
            color="secondary"
            disabled={this.state.runQueryDisable}
          >
            Email Query Results
          </Button>
          <Button
            onClick={() => this.runQuery()}
            className="btn btncreate"
            color="secondary"
            disabled={this.state.runQueryDisable}
          >
            Run Query
          </Button>
        </div>
        {/* <AceEditor
          mode="sql"
          theme="tomorrow"
          onChange={this.handleChange}
          name="UNIQUE_ID_OF_DIV"
          editorProps={{ $blockScrolling: true }}
          style={{ width: "1500px", height: "300px" }}
        /> */}
        <br />
        <span className="redColor">{this.state.errors["sqlerror"]}</span>
        <Card>
          <CardHeader color="warning" icon>
            <CardIcon color="warning">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: "#0c3c54" }}>Results</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              style={{ height: "300px" }}
              data={this.state.data}
              //filterable
              columns={this.state.columns}
              //showPagination={false}
              defaultPageSize={10}
              //showPaginationTop={false}
              //showPaginationBottom={false}
              noDataText={showSpinner}
              //className="-striped -highlight"
            />
            {/*<FixedSizeGrid
                style = {{height: "300px"}}
                itemData={{
                  columns: this.state.columns,
                  rows: this.state.data,
                }}
                // height={150}
                // itemCount={1000}
                // itemSize={35}
                // width={300}

                columnCount={this.state.columns.length}
                columnWidth={300}
                height={150}
                rowCount={this.state.data.length}
                rowHeight={35}
                width={1500}
              >
                    {Cell}
              </FixedSizeGrid>*/}
          </CardBody>
        </Card>
        <center>
          <Dialog
            classes={{
              root: classes.center + " " + classes.modalRoot,
              paper: classes.modal,
            }}
            open={this.state.emailModal}
            TransitionComponent={Transition}
            disableBackdropClick
            disableEscapeKeyDown
            onClose={() => this.setState({ emailModal: false })}
            aria-labelledby="classic-modal-slide-title"
            aria-describedby="classic-modal-slide-description"
          >
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{
                backgroundColor: "#92B54B",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                width: "800px",
              }}
            >
              <h4 className={classes.modalTitle} style={{ color: "#fff" }}>
                <b>Email Query Result</b>
              </h4>
            </DialogTitle>
            <DialogContent
              id="classic-modal-slide-description"
              className={classes.modalBody}
            >
              <div>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <br />
                    <CustomInput
                      labelText="Email Address"
                      id="emailaddress"
                      value={JSON.parse(
                        CryptoJS.AES.decrypt(
                          localStorage.getItem("email"),
                          process.env.REACT_APP_PASS
                        ).toString(CryptoJS.enc.Utf8)
                      )}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.emailaddress,
                        onChange: (event) =>
                          this.handleModalInput(event, "emailaddress"),
                      }}
                    />
                    <span className="redColor">
                      {this.state.errors["emailaddress"]}
                    </span>
                    <br />
                    <CustomInput
                      labelText="Query Title"
                      id="querytitle"
                      //value={localStorage.getItem("email")}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.querytitle,
                        onChange: (event) =>
                          this.handleModalInput(event, "querytitle"),
                      }}
                    />
                    <span className="redColor">
                      {this.state.errors["querytitle"]}
                    </span>
                  </GridItem>
                </GridContainer>
              </div>
            </DialogContent>
            <DialogActions className={classes.modalFooter}>
              <Button
                onClick={() => this.setState({ emailModal: false })}
                className="btn btncreate"
                color="secondary"
              >
                Cancel
              </Button>
              <Button
                className="btn btncreate"
                color="secondary"
                onClick={() => {
                  this.sendEmail();
                }}
                //disabled={this.state.exportDisable}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </center>
      </div>
    );
  }
}

export default withStyles(styles)(QueryTool);



// WEBPACK FOOTER //
// ./src/views/QueryTool/QueryTool.jsx